export default "__VITE_ASSET__CHwAy9el__"